import { RemixBrowser, useLocation, useMatches } from '@remix-run/react';
import * as Sentry from '@sentry/remix';
import { startTransition, StrictMode, useEffect } from 'react';
import { hydrate } from 'react-dom';

Sentry.init({
  dsn: 'https://dc8be4a7b901297a2ac962b6ca3428b8@o308939.ingest.us.sentry.io/4506814042800128',
  environment: process.env.NODE_ENV,
  integrations: [
    Sentry.browserTracingIntegration({
      useEffect,
      useLocation,
      useMatches
    }),
    Sentry.replayIntegration()
  ],
  replaysOnErrorSampleRate: 1,
  replaysSessionSampleRate: 0.1,
  tracesSampleRate: 1
});

startTransition(() => {
  hydrate(
    <StrictMode>
      <RemixBrowser />
    </StrictMode>,
    document
  );
});
